export default "__VITE_PUBLIC_ASSET__941c45de__"